import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { Router } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { MunicipalityService } from '../../common/services/municipality.service';
import { MunicipalitySummary } from '../../common/models/municipality';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
    selector: 'app-sign-up',
    imports: [RouterLink, MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, MatSelectModule, MatIconModule, ReactiveFormsModule],
    templateUrl: './sign-up.component.html',
    styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {

    // isToggled
    isToggled = false;
    isAssociation: boolean = false;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private muncipalityService: MunicipalityService,
        public themeService: CustomizerSettingsService
    ) {
      this.signupForm = this.fb.group({
        personalInfo: this.fb.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
        }),
        municipalityId: ['', Validators.required],
        registrationDetails: this.fb.group({
          email: ['', [Validators.required, Validators.email]],
          password: ['', [Validators.required, Validators.minLength(8)]],
        })
      });

    }

    ngOnInit(): void {
        this.muncipalityService.getMunicipalities().subscribe((data: MunicipalitySummary[]) => {
            this.municipalities = data;
        });
    }

    // Password Hide
    hide = true;
    municipalities: MunicipalitySummary[] = [];

    // Form
    signupForm: FormGroup;
    onSubmit(): void {
      if (this.signupForm.valid) {
        const { personalInfo, registrationDetails, municipalityId, associationDetails } = this.signupForm.value;
          this.muncipalityService.registerMunicipality(
            personalInfo.firstName,
            personalInfo.lastName,
            registrationDetails.email,
            registrationDetails.password,
            municipalityId
          ).subscribe({
            next: _ => this.router.navigate(['/']),
            error: error => console.log('Registration failed', error)
          });
      } else {
        alert('Form is invalid. Please check the fields.');
      }
    }

}
